var lastScroll = 0;
window.addEventListener('scroll', (e)=>{
  let scrollCount = window.pageYOffset;
  let announce = document.querySelector('.announcement-bar-main').clientHeight - 12
  if(window.innerWidth < 992){
    announce = document.querySelector('.announcement-bar-main').clientHeight - 8
  }
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.querySelector('body').classList.remove('scroll-up');
      document.querySelector('body').classList.add('scroll-down');
    }else if(scrollCount < lastScroll){
      document.querySelector('body').classList.remove('scroll-down');
      document.querySelector('body').classList.add('scroll-up');
    }
    lastScroll = scrollCount;
  }, 100);
  if(document.querySelector('.snippet-collection-filter') != null){
    // let header = document.querySelector('.header-main').clientHeight + 36
    // let collFilter = document.querySelector('.snippet-collection-filter').offsetTop - header
    let header = document.querySelector('.header-group').clientHeight + 10
    let collFilter = document.querySelector('.section-collection').offsetTop - scrollCount - header;
    // if(scrollCount >= collFilter){
    if(collFilter <= -announce && collFilter >= -document.querySelector('.header-group').clientHeight){
      if(document.querySelector('body').classList.contains('collection')){
        document.querySelector('body').classList.add('solid-header')
      }else{
        document.querySelector('body').classList.remove('solid-header')
      }
      document.querySelector('.header-group').classList.remove('sticky-header');
      document.querySelector('.header-group').style.top = collFilter+'px';
      // if(document.querySelector('body').classList.contains('scroll-down')){
      //   document.querySelector('.header-group').style.position = 'absolute';
      // }else if(document.querySelector('body').classList.contains('scroll-up')){
      //   document.querySelector('.header-group').style.position = 'fixed';
      //   document.querySelector('.header-group').classList.add('sticky-header');
      // }
    }
    else if(scrollCount <= announce){
      document.querySelector('body').classList.remove('solid-header')
      document.querySelector('.header-group').style.top = '-'+scrollCount+'px'
      document.querySelector('.header-group').classList.remove('sticky-header');
      document.querySelector('.header-group').style.position = '';
    }else{
      if(collFilter <= -document.querySelector('.header-group').clientHeight){
        if(document.querySelector('body').classList.contains('collection')){
          document.querySelector('body').classList.add('solid-header')
        }else{
          document.querySelector('body').classList.remove('solid-header')
        }
        document.querySelector('.header-group').style.top = '-'+document.querySelector('.header-group').clientHeight+'px'
        document.querySelector('.header-group').classList.remove('sticky-header');
        if(document.querySelector('body').classList.contains('scroll-up')){
          document.querySelector('.scroll-up .header-group').style.top = '-'+announce+'px'
        }
      }else{
        document.querySelector('.header-group').classList.add('sticky-header');
      }
      // document.querySelector('.header-group').style.position = '';
    }
  }else{
    if(scrollCount <= announce){
      document.querySelector('.header-group').style.top = '-'+scrollCount+'px'
      document.querySelector('.header-group').classList.remove('sticky-header');
      // document.querySelector('.header-group').style.position = '';
    }else{
      document.querySelector('.header-group').classList.add('sticky-header');
      document.querySelector('.header-group').style.position = '';
    }
  }
  if(document.querySelector('.header-group.sticky-header') != null)
    document.querySelector('.header-group.sticky-header').style.top = '-'+announce+'px'
})
document.querySelectorAll('.menu-burdger button,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelectorAll('.searchlist').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector(".cart_popup").innerHTML = '';
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-wishlist');
    setTimeout(() => {
      document.querySelector(".searchbox #Search").focus();
    },400);
  });
});
document.querySelector('.searchbox_overly').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-search');
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelector('.nav-wrap')){
  document.querySelectorAll('.nav-wrap').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      e.preventDefault();
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
const items = document.querySelectorAll('.localization .disclosure__button');
function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');
  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
    items[i].nextElementSibling.setAttribute('hidden', true)
  }
  if(itemToggle == 'false'){
    this.setAttribute('aria-expanded', 'true');
    this.nextElementSibling.removeAttribute('hidden')
  }
}
items.forEach((item) => item.addEventListener('click', toggleAccordion));
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    // this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);
document.querySelectorAll('.shopify-currency-form input[type="radio"]').forEach((currency) => {
  currency.addEventListener("change", function(){
    currency.closest('form').submit();
  })
})
if( $(".wishlist-head .wishlist-close").length > 0){
  document.querySelector('.wishlist-head .wishlist-close').addEventListener('click', function () {
    var body = document.querySelector('body');
    body.classList.remove('open-wishlist');
  });
}

function toggleWishlistCount(el) {
  const value = el.textContent.trim();
  el.setAttribute('data-count', value);
  el.style.display = value === '0' || value === '' ? 'none' : '';
}

document.querySelectorAll('.th_wlc_product_count').forEach(toggleWishlistCount);

const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList' || mutation.type === 'characterData') {
      const target = mutation.target.nodeType === 3
        ? mutation.target.parentElement
        : mutation.target;

      if (target?.classList?.contains('th_wlc_product_count')) {
        toggleWishlistCount(target);
      }
    }
  });
});

document.querySelectorAll('.th_wlc_product_count').forEach(el => {
  observer.observe(el, {
    childList: true,
    characterData: true,
    subtree: true
  });
});

document.querySelectorAll('.th_wlc_product_count').forEach(function (self) {
  const count = parseInt(localStorage.getItem('th_wlc_pro_count'), 10);

  if (!Number.isNaN(count)) {
    self.innerHTML = count;
  }
});
